exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table tr td[data-v-3a9ec154] {\n    vertical-align: top;\n}\n.td-10[data-v-3a9ec154] {\n    width: 10%;\n}\n.td-15[data-v-3a9ec154] {\n    width: 15%;\n}\n.td-20[data-v-3a9ec154] {\n    width: 20%;\n}\n.form-group[data-v-3a9ec154] {\n    margin: 0;\n}\n", ""]);

// exports
